// extracted by mini-css-extract-plugin
export default {"detailName":"style_detailName__kY6L-"};